module.exports = __webpack_public_path__ + "media/assets/images/big-file-icon-6006bd04a2023f97c89ca2c53b3cbff8.svg";